import React from 'react';

export const ReleasableOrderContext = React.createContext([]);